import { types, actions } from './requests'
export const GETMACHINE_TYPES = {
    ...types('GETMACHINE'),
}
export const GETMACHINE_ACTIONS = {
    ...actions('GETMACHINE'),
}
